import React from "react";
import { useTranslation } from "react-i18next";
import languages from "../i18n/languages";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  return (
    <div>
      {Object.keys(languages).map((lng) => (
        <button 
          key={lng}
          style={{
            fontWeight: i18n.resolvedLanguage === lng ? "bold" : "normal",
            color: i18n.resolvedLanguage === lng ? "green" : "black",
            marginRight: "8px",
            fontStyle: "none",
            fontSize: "12px",
            border: "none",
            background: "transparent"
          }}
          
          onClick={() => i18n.changeLanguage(lng)}
        >
          {languages[lng].nativeName}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
